import { PartyForm } from "Components/Users/UserDetailPageContent/Components/PartyForm/PartyForm";
import { PartyReadOnlyDetail } from "Components/Users/UserDetailPageContent/Components/PartyReadOnlyDetail/PartyReadOnlyDetail";
import { useCheckPermission } from "Hooks/usePermission";
import {
  type IdentityVerificationStatus,
  type PartyDto,
  Permission,
} from "Infrastructure/Api/Api";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { useState } from "react";

type Props = {
  party: PartyDto;
  userID: number;
  currentVerificationStatus: IdentityVerificationStatus;
  isUboUnknown: boolean;
};

export const PartyTabContent = ({
  party,
  userID,
  currentVerificationStatus,
  isUboUnknown,
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const canUpdateParties = useCheckPermission(
    AccessRightCodes.Parties,
    Permission.Update,
  );

  if (isEditing) {
    return (
      <PartyForm
        party={party}
        onCancel={() => setIsEditing(false)}
        onSaved={() => setIsEditing(false)}
      />
    );
  }

  return (
    <PartyReadOnlyDetail
      party={party}
      userID={userID}
      currentVerificationStatus={currentVerificationStatus}
      onEdit={canUpdateParties ? () => setIsEditing(true) : undefined}
      isUboUnknown={isUboUnknown}
    />
  );
};
